export default __webpack_public_path__ + "static/media/10001.e06a01b2.png";